export const checkForBoundsAddressType = address => {
  if (address.geometry.location_type !== 'APPROXIMATE') return false
  for (let type of address.types) {
    if (boundsAddressType.includes(type)) return true
  }

  return false
}

const boundsAddressType = [
  'political',
  'postal_code',
  'country',
  'locality',
  'neighborhood',
  'sublocality',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality_level_3',
  'sublocality_level_4',
  'sublocality_level_5',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'administrative_area_level_3',
  'administrative_area_level_4',
  'administrative_area_level_5',
  'colloquial_area',
  'continent'
]
